import httpClient from "../../api/httpClient";
import _ from "lodash";
import { fetchWrapper } from "../../utils/helper";
import { countries } from "../../utils/helper";

export default {
  namespaced: true,
  state: {
    loading: false,
    approvementLoading: false,
    recalculationLoading: false,
    error: '',
    success: '',
    clientInvoicePayments: [],
    dates: [],
    filter: {
      date: "",
      country: "ALL",
    },
    countries,
  },
  mutations: {
    update(state, { path, value }) {
      _.set(state, path, value)
    },
  },
  getters: {
    filter: (state) => state.filter,
    getAttribute: (state) => (path) => state[path],
  },
  actions: {
    getDates({ commit }) {
      fetchWrapper(async () => {
        const { data } = await httpClient.get("/client-invoice-payments/dates");
        const dates = data.map((date) => ({
          label: date.invoice_date,
          value: date.invoice_date,
        }));
        commit("update", { path: 'dates', value: dates });
        // Set first date as the default date if date wasn't set
        commit("update", { path: 'filter.date', value: dates[0].value });
      }, commit)
    },
    search({ commit, state }) {
      return fetchWrapper(async () => {
        const { data } = await httpClient.get("/client-invoice-payments/search", {
          params: {
            date: state.filter.date,
            country: state.filter.country,
          },
        });
        commit("update", { path: "clientInvoicePayments", value: data });
      }, commit)
    },
    changeApprovement({ commit, dispatch }, { id, isApproved }) {
      return fetchWrapper(async (id, isApproved) => {
        const { data } = await httpClient.put(
          "/client-invoice-payments/change-approvement",
          {
            id,
            isApproved,
          },
        );
        await dispatch('search');
        return data;
      }, commit, [ id, isApproved ], { loadingPath: "approvementLoading" })
    },
    recalculate({ commit }, id) {
      return fetchWrapper(async (id) => {
        const { data } = await httpClient.get(
          `/client-invoice-payments/${id}/recalculate`,
        );
        return data;
      }, commit, [ id ], { loadingPath: "recalculationLoading" })

    },
  },
};
